import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/forgot-password.jpg'
import _imports_1 from '@/assets/images/logos/sidebarlogo.png'


const _hoisted_1 = { class: "bg-white dark:bg-[#0a0e19] py-[60px] md:py-[80px] lg:py-[135px]" }
const _hoisted_2 = { class: "mx-auto px-[12.5px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1255px]" }
const _hoisted_3 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-[25px] items-center" }
const _hoisted_4 = { class: "xl:pl-[90px] 2xl:pl-[120px] order-1 lg:order-2" }
const _hoisted_5 = {
  key: 0,
  class: "mb-4 p-3 bg-green-100 text-green-700 rounded-md"
}
const _hoisted_6 = {
  key: 1,
  class: "mb-4 p-3 bg-red-100 text-red-700 rounded-md"
}
const _hoisted_7 = { class: "mb-[15px] relative" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "flex items-center justify-center gap-[5px]" }
const _hoisted_10 = {
  key: 0,
  class: "material-symbols-outlined"
}
const _hoisted_11 = {
  key: 1,
  class: "inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
}
const _hoisted_12 = { class: "mt-[15px] md:mt-[20px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "xl:-mr-[25px] 2xl:-mr-[45px] rounded-[25px] order-2 lg:order-1" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "forgot-password-image",
            class: "rounded-[25px]"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("img", {
            src: _imports_1,
            alt: "logo",
            class: "inline-block max-w-[160px]"
          }, null, -1)),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "my-[17px] md:my-[25px]" }, [
            _createElementVNode("h1", { class: "font-semibold text-[22px] md:text-xl lg:text-2xl mb-[5px] md:mb-[12px]" }, " Forgot your password? "),
            _createElementVNode("p", { class: "font-medium leading-[1.5] lg:text-md text-[#445164] dark:text-gray-400" }, " Enter the email address you used when you joined and we'll send you instructions to reset your password. ")
          ], -1)),
          (_ctx.successMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.successMessage), 1))
            : _createCommentVNode("", true),
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.errorMessage), 1))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleResetPassword && _ctx.handleResetPassword(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _cache[2] || (_cache[2] = _createElementVNode("label", { class: "mb-[10px] md:mb-[12px] text-black dark:text-white font-medium block" }, " Email Address ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                type: "email",
                class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                placeholder: "example@clickai.live",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.email]
              ])
            ]),
            _createElementVNode("button", {
              type: "submit",
              disabled: _ctx.isLoading,
              class: "md:text-md block w-full text-center transition-all rounded-md font-medium mt-[20px] md:mt-[25px] py-[12px] px-[25px] text-white bg-primary-500 hover:bg-primary-400 disabled:opacity-70 disabled:cursor-not-allowed"
            }, [
              _createElementVNode("span", _hoisted_9, [
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_10, " autorenew "))
                  : _createCommentVNode("", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.isLoading ? 'Sending...' : 'Reset Password'), 1)
              ])
            ], 8, _hoisted_8)
          ], 32),
          _createElementVNode("p", _hoisted_12, [
            _cache[4] || (_cache[4] = _createTextVNode(" Back to ")),
            _createVNode(_component_RouterLink, {
              to: "/authentication/sign-in",
              class: "text-primary-500 transition-all font-semibold hover:underline"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" Sign In ")
              ])),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}